var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 52,
    viewBox: "0 0 66 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.633789,
    y: 10.6248,
    width: 64.7322,
    height: 40.7094,
    rx: 3.86461,
    fill: "#FEC200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1805 27.5435L31.9686 18.8307C32.5375 18.2667 33.4561 18.2713 34.0194 18.8409L42.6352 27.5537C43.5403 28.4689 42.892 30.0219 41.6048 30.0219H37.1472C36.8572 30.0219 36.6222 30.2569 36.6222 30.5469V40.1692C36.6222 42.1035 35.0541 43.6715 33.1199 43.6715C31.1856 43.6715 29.6176 42.1035 29.6176 40.1692V30.5469C29.6176 30.2569 29.3825 30.0219 29.0926 30.0219H24.2008C22.9067 30.0219 22.2615 28.4547 23.1805 27.5435Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22266 4.91914V11.1039H60.0518L58.7322 9.18505C57.2902 7.08823 54.9084 5.83559 52.3636 5.83559H37.8303L33.1632 1.20856C32.4395 0.490987 31.4615 0.0883789 30.4423 0.0883789H10.0534C7.38546 0.0883789 5.22266 2.25119 5.22266 4.91914Z",
    fill: "#FFE07C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.e150e59ddefdbc395cf3f2f2d774d595.svg";
export { ForwardRef as ReactComponent };